<span class="fa fa-cog fa-spin"></span>
<div class="loading-text">{{ text }}...</div>
